import { createContext, useContext, useState } from 'react';

const GlobalVariableContext = createContext({});

interface Props {
    children: React.ReactNode;
}

export const GlobalVariableProvider = ({ children }: Props) => {
    const [showTnc, setShowTnc] = useState(false);
    const [showingTnc, setShowingTnc] = useState(false);
    const [showCustomBanner, setShowCustomBanner] = useState(false);


    const [showingForceChangePassword, setShowingForceChangePassword] = useState(false);

    return (
        <GlobalVariableContext.Provider value={{ showTnc, setShowTnc,showingTnc, setShowingTnc,showingForceChangePassword, setShowingForceChangePassword,showCustomBanner, setShowCustomBanner }}>
            {children}
        </GlobalVariableContext.Provider>
    );
};

export const useGlobalVariable = () => {
    return useContext(GlobalVariableContext);
};

export default GlobalVariableContext;
